import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { LocalState, MakeStore } from "../lib/types";
import { PERSIST_VERSION } from "../lib/persist";
import { sessionService } from "@/services/api/session";

type LocalStore = MakeStore<LocalState>;

export const useLocalStore = create<LocalStore>()(
  persist(
    (set) => ({
      page: "connection",
      error: null,
      errorCode: null,
      userProfile: null,
      autoLogin: false,
      documentType: null,
      setPage: (page) => set({ page }),
      setError: (error) => set({ error, errorCode: null }),
      setErrorCode: (errorCode) => set({ errorCode }),
      setUserProfile: (userProfile) => set({ userProfile }),
      setAutoLogin: (autoLogin) => set({ autoLogin }),
      setDocumentType: (documentType) => set({ documentType }),
    }),
    {
      // Bumped from "eledone_addin_state" → "_v2" to drop the legacy uploadMode
      // field cleanly without an explicit migration step.
      name: "eledone_addin_state_v2",
      storage: createJSONStorage(() => localStorage),
      partialize: ({ userProfile, autoLogin, error, errorCode, page, documentType }) => ({
        userProfile,
        autoLogin,
        error,
        errorCode,
        page,
        documentType,
      }),
      version: PERSIST_VERSION,
    },
  ),
);

// Listen to token changes and clear user profile when tokens are cleared
sessionService.onTokenChange((event) => {
  if (event === "tokens-cleared") {
    useLocalStore.getState().setUserProfile(null);
    useLocalStore.getState().setAutoLogin(false);
  }
});
